export default __webpack_public_path__ + "static/media/catalogos.bd60340b.svg";